import { Injectable } from '@angular/core';
import { PersonAuthDetailsDto } from '@auto-editor/shared/models';
import {
  LocalStorageKey,
  LocalStorageService
} from '@auto-editor/data-access-local-storage';

@Injectable({ providedIn: 'root' })
export class UserService {
  readonly EDIT_AUTHORITY = 'SED_SURVEY_EDIT';
  private localStorageKey = LocalStorageKey;
  userInfo: PersonAuthDetailsDto;

  constructor(private localStorage: LocalStorageService) {}

  userLoggedIn(): boolean {
    if (this.userInfo) {
      return true;
    } else {
      if (this.localStorage.getData(this.localStorageKey.userLogged)) {
        this.userInfo = JSON.parse(
          this.localStorage.getData(this.localStorageKey.userLogged)
        );
        return true;
      } else {
        return false;
      }
    }
  }

  logOut(): void {
    this.userInfo = null;
    this.localStorage.clearData();
  }
}
